module.exports = __webpack_public_path__ + "img/rg9.383b003b.jpg";